import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import useTranslationAdmin from "../useTranslationAdmin";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import RefreshButton from "../../common/widgets/RefreshButton";
import "./ApplicationListBlock.scss";
import ApplicationList from "./ApplicationList";

function ApplicationListBlock({filter}) {
  const { t, loading: tLoading } = useTranslationAdmin();
  useShowLoader(tLoading, "ApplicationListBlock");

  return (
    <div className="ApplicationListBlock">
      <Row>
        <Col>
          <h1>{t("admin:admin_application_list_title")}</h1>
        </Col>
        <Col className={"button-col"}>
          <RefreshButton />
        </Col>
      </Row>
      <Row>
        <Col>
          <ApplicationList filter={filter}/>
        </Col>
      </Row>
    </div>
  );
}

export default ApplicationListBlock;
